import { Component, OnInit } from '@angular/core';
import {ApprovalModel} from '../../../shared/dto/approval.model';
import {ReturnRequestComponent} from '../../blacklist-process-verification/blacklist-verification-request-viewer/return-request/return-request.component';
import {UserRoleEnum} from '../../../shared/enums/user-role.enum';
import {TokenStorageService} from '../../../shared/service/token-storage.service';
import {RemarkComponent} from '../../../approval-process/remark/remark.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {FwdRemarkComponent} from '../../../approval-process/fwd-remark/fwd-remark.component';
import {ReturnRemarkComponent} from '../../../approval-process/return-remark/return-remark.component';
import {ApprovalService} from '../../../service/approval.service';
import {ActivatedRoute} from '@angular/router';
import {BlacklistApproveChecklistComponent} from '../../blacklist-approve-checklist/blacklist-approve-checklist.component';
import {WorkflowEnum} from '../../../shared/enums/workflow.enum';

@Component({
  selector: 'app-blacklist-authorization-request-viewer',
  templateUrl: './blacklist-authorization-request-viewer.component.html',
  styleUrls: ['./blacklist-authorization-request-viewer.component.scss']
})
export class BlacklistAuthorizationRequestViewerComponent implements OnInit {

  appRefNo: number;
  userName: string;
  userRole: string;
  stage : string = WorkflowEnum.BLACKLIST;
  type: string;
  DG:string = UserRoleEnum.DG;
  SHO:string = UserRoleEnum.SHO;
  EXM:string = UserRoleEnum.EXM;
  approvalModel: ApprovalModel = new ApprovalModel();

  constructor(private route: ActivatedRoute, private tokenStorageService: TokenStorageService,
              private approvalService: ApprovalService, private modalService: NgbModal) {
    this.route.paramMap.subscribe(params => {
      this.appRefNo = +this.decodeBase64(params.get('id'));
    });
  }

  ngOnInit() {
    this.userName=this.tokenStorageService.getUserObjectToken().username;
    this.userRole=this.tokenStorageService.getUserObjectToken().userroleCode;
  }
  decodeBase64(code: string): string {
    return atob(code);
  }

  rejectRequest() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'Reject';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(RemarkComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService)
  }

  forwardToDg() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'FWD_DG';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(FwdRemarkComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService)
  }

  returnRequest() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'RETURN';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(ReturnRemarkComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService);
  }

  approveRequest() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'APPROVE';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;
    this.approvalModel.stage = WorkflowEnum.BLACKLIST;

    const modalRef = this.modalService.open(BlacklistApproveChecklistComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService);
  }

  returnBlacklist() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'RETURN';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(ReturnRequestComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService);
  }

  blacklistData() {

  }
}
